export default __webpack_public_path__ + "static/media/whiteCompleteLogo.77cb3034.svg";